/**
 * PD-17379 — the sign-in or confirmation code in a text the Android storefront
 * app received through Google's SMS Retriever.
 *
 * Our code texts end with the `@host #code` line (PD-16471), so the code is
 * read from there first; it is the one place in the text that is always ours,
 * even when a storefront has written its own wording. A text without that line
 * (no host was known when it was sent) falls back to the one six-digit number
 * in it. Two different six-digit numbers and no autofill line is ambiguous,
 * and null is safer than filling the wrong one in: the person types it.
 */
const AUTOFILL_LINE_CODE = /#(\d{6})\s*$/;
/** Exactly six digits, not part of a longer number. */
const STANDALONE_SIX_DIGITS = /(?:^|\D)(\d{6})(?!\d)/g;

export function extractSmsCode(message: string | null | undefined): string | null {
	if (message == null) {
		return null;
	}

	const fromAutofillLine = AUTOFILL_LINE_CODE.exec(message);
	if (fromAutofillLine?.[1] != null) {
		return fromAutofillLine[1];
	}

	const candidates = new Set<string>();
	for (const match of message.matchAll(STANDALONE_SIX_DIGITS)) {
		if (match[1] != null) {
			candidates.add(match[1]);
		}
	}
	if (candidates.size !== 1) {
		return null;
	}
	const [only] = candidates;
	return only ?? null;
}
